import axios from 'axios';

export default {
	namespaced: true,
  state: {
		meta: {},
    templates: [],
		categories: [],
		cancelToken: null,
  },
  getters: {
    templates: (state) => state.templates,
    meta: (state) => state.meta,
    categories: (state) => state.categories,
  },
  mutations: {
    SET_TEMPLATES(state, payload) {
			state.meta = payload;
      state.templates = payload.data;
    },
    UPDATE_PAGE(state, payload) {
			state.meta.current_page = payload;
    },
		UPDATE_CANCEL_TOKEN(state) {
      if (state.cancelToken) {
        state.cancelToken.cancel('Request canceled due to a new request.');
      }
      state.cancelToken = axios.CancelToken.source();
    },
		SET_CATEGORIES(state, payload) {
			const emptySelect = [
				{
					value: '',
					text: 'Categorias',
				},
			];
			const categories = payload.map(item => ({
				value: item.category,
				text: item.category,
			}));
			state.categories = emptySelect.concat(categories);
		},
  },
  actions: {
		async GET_CATEGORIES({ commit }, params = {}) {
			return axios.get(`answer_templates/categories`, {
				params,
			}).then(({ data }) => {
				commit('SET_CATEGORIES', data)
			}).catch(() => {});
		},
		async GET_TEMPLATES({ commit, state }, params = {}) {
      commit('UPDATE_CANCEL_TOKEN');
      return axios.get('/answer_templates', {
        params,
        cancelToken: state.cancelToken.token,
      }).then(({ data }) => {
        commit('SET_TEMPLATES', data);
      }).catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Request canceled:', error.message);
        } else {
          console.error('Error fetching templates:', error);
        }
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/answer_templates.js